/**
 * window.localStorage 浏览器永久缓存
 * @method set 设置永久缓存
 * @method get 获取永久缓存
 * @method remove 移除永久缓存
 * @method clear 移除全部永久缓存
 */
export const Local = {
  // 设置永久缓存
  set(key: string, val: any) {
    let stringify = val;
    if (typeof val === 'object') {
      stringify = JSON.stringify(val);
    }
    window.localStorage.setItem(key, stringify);
  },
  // 获取永久缓存
  get(key: string) {
    const json: string | null = window.localStorage.getItem(key);
    if (json === 'undefined' || json === null) {
      return undefined;
    }
    try {
      if (json?.startsWith('{') || json?.startsWith('[')) {
        return JSON.parse(json);
      } else {
        return json;
      }
    } catch (error) {
      console.log(error);
      return json;
    }
  },
  // 移除永久缓存
  remove(key: string) {
    window.localStorage.removeItem(key);
  },
  // 移除全部永久缓存
  clear() {
    window.localStorage.clear();
  },
};

/**
 * window.sessionStorage 浏览器临时缓存
 * @method set 设置临时缓存
 * @method get 获取临时缓存
 * @method remove 移除临时缓存
 * @method clear 移除全部临时缓存
 */
export const Session = {
  // 设置临时缓存
  set(key: string, val: any) {
    let json = val;
    if (typeof val === 'object') {
      json = JSON.stringify(val);
    }
    window.sessionStorage.setItem(key, json);
  },
  // 获取临时缓存
  get(key: string) {
    const json: any = window.sessionStorage.getItem(key);

    if (json === 'undefined') {
      return undefined;
    }

    try {
      return JSON.parse(json);
    } catch (error) {
      // console.error(error);
      console.log(error);
      return json;
    }
  },
  // 移除临时缓存
  remove(key: string) {
    window.sessionStorage.removeItem(key);
  },
  // 移除全部临时缓存
  clear() {
    window.sessionStorage.clear();
  },
};

// @ts-ignore
window.Local = Local;
// @ts-ignore
window.Session = Session;
